module.exports = __webpack_public_path__ + "aa45dda1d990975dc404fa530b92ffeb.png";